import React from 'react';
import classnames from 'classnames';
import { ConnectedResidentDiscount } from './ResidentDiscount';
import { ABUtils } from '../../utils';
import { ResidentDiscountMessageMobile } from './ResidentDiscountMessageMobile';

export const ResidentDiscount = () => {
    const { isCssVariationMobile, isResidentDiscountPaxType } = ABUtils.getABs();
    const wrapperClass = classnames({
        'odf-flex-container-row odf-flex-container-nogutter': true,
        'odf-space-inner-top-s odf-space-inner-bottom-s': isCssVariationMobile,
        'odf-space-outer-top-s odf-space-inner-top-m odf-space-inner-bottom-m': !isCssVariationMobile,
    });
    return (
        <ConnectedResidentDiscount>
            {({ hasNonAdults, hasRegions, regionsText }) =>
                hasRegions ? (
                    <div className={wrapperClass}>
                        <div className="odf-flex-item odf-flex-item-align-center">
                            <ResidentDiscountMessageMobile
                                hasNonAdults={hasNonAdults}
                                regionsText={regionsText}
                                isResidentDiscountPaxType={isResidentDiscountPaxType}
                            />
                        </div>
                    </div>
                ) : null
            }
        </ConnectedResidentDiscount>
    );
};
